import { inject } from '@angular/core';
import { MixpanelService } from 'src/app/@services/mixpanel.service';
import { environment } from 'src/environments/environment';

// The projector runs all day, so it skips session recording.
export const isPrimaryScreenUrl = (search: string): boolean => {
  try {
    return new URLSearchParams(search).get('isPrimaryScreen') === 'true';
  } catch {
    return false;
  }
};

export function appMixpanelInitializer() {
  const mixpanelService = inject(MixpanelService);

  return (): void => {
    if (environment.mixpanelToken) {
      mixpanelService.initialize(
        environment.mixpanelToken,
        isPrimaryScreenUrl(window.location.search)
          ? { record_sessions_percent: 0 }
          : undefined
      );
    }
  };
}
